/**
 * InternalLinks - SEO internal linking section for tool pages
 * Helps crawlers discover related pages and distributes PageRank
 */
import { Link } from "react-router-dom";

const LINK_GROUPS = {
  seo: [
    { href: "/tools/seo", label: "SEO Tools" },
    { href: "/free/keyword-research", label: "Free Keyword Research" },
    { href: "/free/backlink-checker", label: "Free Backlink Checker" },
    { href: "/free/seo-audit", label: "Free SEO Audit" },
    { href: "/tools/site-audit", label: "Complete Site Audit" },
    { href: "/free/domain-authority-checker", label: "Domain Authority Checker" },
  ],
  content: [
    { href: "/tools/content", label: "Content Tools" },
    { href: "/ai-blog", label: "AI Blog Generator" },
    { href: "/free/plagiarism-checker", label: "Plagiarism Checker" },
    { href: "/free/word-counter", label: "Word Counter" },
    { href: "/free/readability-checker", label: "Readability Checker" },
  ],
  social: [
    { href: "/tools/social-media", label: "Social Media Tools" },
    { href: "/free/hashtag-generator", label: "Hashtag Generator" },
    { href: "/tools/youtube", label: "YouTube SEO Tools" },
  ],
  design: [
    { href: "/tools/design", label: "Design Tools" },
    { href: "/tools/design/pdf", label: "PDF Tools" },
    { href: "/brand-kit", label: "Brand Kit Generator" },
  ],
  compare: [
    { href: "/compare/smallseotools", label: "MarkeeMix vs SmallSEOTools" },
    { href: "/compare/prepostseo", label: "MarkeeMix vs Prepostseo" },
    { href: "/compare/ubersuggest", label: "MarkeeMix vs Ubersuggest" },
  ],
};

function LinkGroup({ cat, links }) {
  return (
    <div>
      <p className="text-xs font-medium text-gray-400 uppercase mb-2">{cat}</p>
      <ul className="space-y-1">
        {links.map((link) => (
          <li key={link.href}>
            <Link to={link.href} className="text-sm text-violet-600 hover:text-violet-800 hover:underline">
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function InternalLinks({ currentPath = "", categories = ["seo", "content", "social", "compare"] }) {
  const visibleGroups = categories.map((cat) => {
    const all = LINK_GROUPS[cat] || [];
    const links = [];
    for (const l of all) {
      if (l.href !== currentPath) links.push(l);
      if (links.length === 5) break;
    }
    return { cat, links };
  });

  return (
    <section className="max-w-4xl mx-auto px-4 py-8 border-t border-gray-100">
      <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">Explore More Tools</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {visibleGroups.map((g) => (
          <LinkGroup key={g.cat} cat={g.cat} links={g.links} />
        ))}
      </div>
    </section>
  );
}
